<template>
  <div class="wrapper">
    <div class="tag-finder">
      <div class="header">
        <h1 class="header__title">タグ一覧</h1>
        <button class="header__close-btn" @click="close">
          <i class="fa fa-close"></i>
        </button>
        <p class="header__description">
          紐付けるカテゴリ・タグを選択して下さい。
          子カテゴリだけを紐付けても、親カテゴリの記事リストには表示されません。
          紐付けたタグを再度選択すると、紐付けが解除されます。
        </p>
      </div>
      <div class="body">
        <div class="body__left">
          <ul class="menu-list">
            <li class="menu-item">
              <a
                @click="tab = 'category'"
                :class="tab == 'category' ? 'active' : ''"
              >
                カテゴリー
              </a>
            </li>
            <li class="menu-item">
              <a @click="tab = 'tag'" :class="tab == 'tag' ? 'active' : ''">
                タグ
              </a>
            </li>
          </ul>
        </div>
        <div class="body__right body-right">
          <div class="body-right__search-bar">
            <input
              type="text"
              class="form-control"
              placeholder="検索キーワード"
              v-model="query"
            />
          </div>
          <div class="body-right__category" v-if="tab == 'category'">
            <div class="category-wrap">
              <TagFinderCategoryList
                :selectedTaxonomyIds="selectingIds"
                :categories="filteredRootCategories"
                :allCategories="filteredCategories"
                @toggle-select="toggleSelect($event)"
              />
            </div>
          </div>
          <div class="body-right__tag" v-if="tab == 'tag'">
            <ul class="tag-list">
              <li class="tag-list__item" v-for="tag in filteredTags">
                <a
                  :class="['badge', { selected: isSelected(tag.id) }]"
                  @click="toggleSelect(tag.id)"
                >
                  {{ tag.name }}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="footer">
        <button class="footer__kakutei-btn btn-green" @click="done">
          確定
        </button>
      </div>
    </div>
    <button class="backdrop" @click="close"></button>
  </div>
</template>

<script>
import TagFinderCategoryList from './TagFinderCategoryList.vue';
import { getAncestorTagList } from '../../libs/tags';

export default {
  name: 'TagFinder',
  components: {
    TagFinderCategoryList,
  },
  props: {
    selected: {
      // tag objectの配列
      type: Array,
      default: () => [],
    },
    autoSelectAncestors: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      taxonomies: [],
      tab: 'category',
      selectingIds: [...this.selected.map((taxonomy) => taxonomy.id)],
      query: '',
    };
  },
  beforeMount() {
    $.ajax({
      url: '/api/tags',
    }).then((response) => {
      this.taxonomies = response.tags;
    });
  },
  computed: {
    categories() {
      return this.taxonomies.filter((taxonomy) => taxonomy.tag_type !== 'tag');
    },
    filteredCategories() {
      const queryMatchedCategoryIds = this.categories
        .filter((category) => category.name.includes(this.query))
        .map((category) => category.id);
      // queryにマッチしたカテゴリの先祖カテゴリも表示する
      const filteredIds = queryMatchedCategoryIds.flatMap((categoryId) => {
        const ancestorTagIds = getAncestorTagList(
          this.categories,
          categoryId
        ).map((category) => category.id);
        return [categoryId, ...ancestorTagIds];
      });
      const uniqFilteredIds = [...new Set(filteredIds)].sort((a, b) => a - b);
      return uniqFilteredIds.map((id) =>
        this.taxonomies.find((taxonomy) => taxonomy.id === id)
      );
    },
    filteredRootCategories() {
      return this.filteredCategories.filter(
        (category) => category.parent_id === null
      );
    },
    tags() {
      return this.taxonomies.filter((taxonomy) => taxonomy.tag_type === 'tag');
    },
    filteredTags() {
      if (this.query.length > 0) {
        return this.tags.filter((t) => t.name.includes(this.query));
      } else {
        return this.tags;
      }
    },
    selectingTaxonomies() {
      return this.selectingIds.map((id) => {
        return this.taxonomies.find((t) => t.id === id);
      });
    },
  },
  methods: {
    isSelected(taxonomyId) {
      return this.selectingIds.includes(taxonomyId);
    },
    toggleSelect(taxonomyId) {
      if (this.isSelected(taxonomyId)) {
        this.selectingIds = this.selectingIds.filter((id) => id !== taxonomyId);
      } else {
        const taxonomy = this.taxonomies.find((t) => t.id === taxonomyId);
        // カテゴリの場合、必要であれば先祖も全て選択する
        if (this.autoSelectAncestors && taxonomy.tag_type !== 'tag') {
          const ancestorIds = getAncestorTagList(
            this.categories,
            taxonomyId
          ).map((t) => t.id);
          ancestorIds.forEach((id) => this.selectTaxonomy(id));
        }
        this.selectTaxonomy(taxonomyId);
      }
    },
    selectTaxonomy(taxonomyId) {
      if (this.isSelected(taxonomyId)) {
        return;
      }
      this.selectingIds = [...this.selectingIds, taxonomyId];
    },
    close() {
      bus.$emit('close-tag-finder');
    },
    done() {
      bus.$emit('done-tag-finder', this.selectingTaxonomies);
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;
}

.tag-finder {
  background: white;
  width: 800px;
  height: 500px;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-left: -400px;
  margin-top: -250px;
  display: flex;
  flex-direction: column;
  z-index: 100;
}

.header {
  padding: 10px;
  border-bottom: 1px solid #eee;
  position: relative;

  &__title {
    font-size: 16px;
    line-height: 20px;
    font-weight: bold;
    margin: 0 0 10px;
  }

  &__description {
    font-size: 1.3rem;
    line-height: 2rem;
  }

  &__close-btn {
    position: absolute;
    top: 10px;
    right: 10px;
    font-size: 20px;
    border: none;
    background-color: transparent;
    cursor: pointer;
  }
}

.body {
  display: flex;
  flex: 1;

  &__left {
    width: 200px;
  }

  &__right {
    flex: 1;
    border-left: 1px solid #eee;
  }
}

.menu-item {
  a {
    display: block;
    line-height: 20px;
    font-size: 16px;
    padding: 10px;
    border-bottom: 1px solid #eee;
  }

  a:hover {
    background: #efefef;
  }

  a.active {
    background: #ccc;
  }
}

.body-right {
  padding: 10px;
  position: relative;

  &__search-bar {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    padding: 10px;
  }

  &__category {
    overflow-y: scroll;
    height: 320px;
    padding-top: 40px;
  }

  &__tag {
    overflow-y: scroll;
    height: 320px;
    padding-top: 40px;
  }
}

.category-wrap {
  margin: 0 0 20px;
}

.tag-list {
  margin-left: -5px;
  &__item {
    display: inline-block;
    margin: 0 5px 5px 0;
  }
}

.badge {
  cursor: pointer;
  border: 1px solid #eee;

  &:hover {
    opacity: 0.8;
  }
  &.selected {
    background: #fff7ad;
    border: 1px solid #e8e800;
  }
}

.footer {
  text-align: center;
  padding: 15px 0;
  text-align: center;
  border-top: 1px solid #eee;

  &__kakutei-btn {
    padding: 10px 20px;
    font-size: 16px;
  }
}

.backdrop {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: none;
  background: rgba(0, 0, 0, 0.3);
}
</style>
